/** Böngésző-chrome minimalizálás kamera módban (mobil Chrome / Safari). */

export function isStandalonePwa() {
  if (typeof window === "undefined") return false;
  if (window.matchMedia?.("(display-mode: standalone)")?.matches) return true;
  // eslint-disable-next-line no-restricted-globals
  return !!window.navigator.standalone;
}

export function readVisualViewportBox() {
  if (typeof window === "undefined") {
    return { top: 0, left: 0, width: 1, height: 1 };
  }
  const vv = window.visualViewport;
  return {
    top: vv?.offsetTop ?? 0,
    left: vv?.offsetLeft ?? 0,
    width: vv?.width ?? window.innerWidth,
    height: vv?.height ?? window.innerHeight,
  };
}

export async function requestImmersiveFullscreen(element) {
  if (!element?.requestFullscreen && !element?.webkitRequestFullscreen) return false;
  try {
    if (element.requestFullscreen) await element.requestFullscreen({ navigationUI: "hide" });
    else if (element.webkitRequestFullscreen) await element.webkitRequestFullscreen();
    return !!(document.fullscreenElement || document.webkitFullscreenElement);
  } catch {
    return false;
  }
}

export async function exitImmersiveFullscreen() {
  try {
    const active = document.fullscreenElement || document.webkitFullscreenElement;
    if (!active) return;
    if (document.exitFullscreen) await document.exitFullscreen();
    else if (document.webkitExitFullscreen) await document.webkitExitFullscreen();
  } catch {
    /* user gesture / iOS */
  }
}
